
import { mfPessoaEvento, kooponPessoaMensagensRetorno} from '@/constants';
import { TipoPessoa } from "../../models/tipo_pessoa_model";
import tipoPessoaService from "../../services/tipo_pessoa_service";
import customEvents from "../../services/custom_events";
import ErrosBackend from "../../libs/comum/helpers/comum_error_parse";

export default {
  name: "kooponPessoaTipoPessoa",

  components: {},

  data: () => ({
    tipoPessoa: new TipoPessoa(),
    criarOutroTipoPessoa: false,
    avisoTiposDePessoaPermitidos: "permitido",
    tokenEvento: '',
    descricao: '',
  }),
  props: {
    showModal: {type: Boolean, default: true},
    idTipoPessoa: {type: Number},
    permiteCriacaoDeOutroTipoPessoa: {type: Boolean, default: true}
  },
  methods: {
    removerHintPendencia() {
      this.tipoPessoa.removerPendencia("descricao");
    },
    gravar(tipoPessoa: TipoPessoa, id: number) {
      if (tipoPessoa.validar()) {
        if (tipoPessoa.isNew()) {
          return this.criar(tipoPessoa);
        }
        return this.atualizar(tipoPessoa, this.idTipoPessoa);
      }
    },
    async criar(obj: TipoPessoa) {
      customEvents.exibeCarregando();
      try {
        const objNovo = await tipoPessoaService.criar(obj);
        this.tipoPessoa = new TipoPessoa();
        const parametros = {tipoPessoa: objNovo, tipoEvento: mfPessoaEvento.crud.TIPO_PESSOA_CRIADA}
        this.$emit("tipoPessoaCriado", parametros);
        if (!this.criarOutroTipoPessoa) {
          this.fecharModal();
        }
      } catch (error) {
        const MSG_DEFAULT =
          "Houve um problema no momento da criação do tipo de pessoa.";
        customEvents.exibeAlerta({
          msg: ErrosBackend.parseErrors(error) || MSG_DEFAULT,
        });
      } finally {
        customEvents.escondeCarregando();
      }
    },
    async atualizar(obj: TipoPessoa, id: number) {
      customEvents.exibeCarregando();
      try {
        const objAtualizado = await tipoPessoaService.atualizar(obj, id);
        const parametros = {tipoPessoa: objAtualizado, tipoEvento: mfPessoaEvento.crud.TIPO_PESSOA_ATUALIZADA}
        this.$emit("tipoPessoaCriado", parametros);
        this.fecharModal();
      } catch (error) {
        const MSG_DEFAULT ="Houve um problema no momento de editar o tipo de pessoa.";
        customEvents.exibeAlerta({
          msg: ErrosBackend.parseErrors(error) || MSG_DEFAULT,
        });
      } finally {
        customEvents.escondeCarregando();
      }
    },
    buscarPorId (id: number){
      customEvents.exibeCarregando();
      tipoPessoaService.buscarTipoPessoaPorId(id)
      .then((obj)=>{
        return this.tipoPessoa = obj;
      }).catch ((error) => {
        const MSG_DEFAULT = "Houve um problema no momento de buscar o tipo de pessoa escolhida.";
        customEvents.exibeAlerta({
          msg: ErrosBackend.parseErrors(error) || MSG_DEFAULT,
        });
      }).finally (()=>{
        customEvents.escondeCarregando();
      })
    },
    fecharModal() {
      document.dispatchEvent( new CustomEvent(mfPessoaEvento.modal.MODAL_TIPO_PESSOA_FOI_FECHADO, {}));
      this.tipoPessoa = new TipoPessoa();
      this.$emit("fecharModalTipoPessoa");
    },
    exibirMensagemSistemasComplementares() {
      this.$alert({
        tipo: "info",
        message: kooponPessoaMensagensRetorno.INFO_SISTEMAS_COMPLEMENTARES,
      });
    },
  },
  mounted() {
    if(this.idTipoPessoa){
      this.buscarPorId(this.idTipoPessoa)
    }
  },
};
